<!-- Shopping.vue -->
<template>
	<mt-popup
		v-model="isShowcartInfo"
		position="bottom"
		v-if="detailInfo"
		v-bind:close-on-click-modal="false"
	>
		<div class="ui-add-shopping" v-if="detailInfo">
			<div class="shopping-info">
				<div class="info-header">
					<img
						src="../../../../assets/image/home/default_image_banner.png"
						class="info-image"
						v-if="!detailInfo.photos || detailInfo.photos.length <= 0"
					/>
					<img
						v-bind:src="detailInfo.photos[0]"
						class="info-image"
						v-if="detailInfo.photos && detailInfo.photos.length > 0"
					/>
					<div>

						<span
							class="header-price"
							>${{ utils.currencyPrice(detailInfo.promotion_type?detailInfo.promotion_price:detailInfo.goods_price) }}</span
						>

						<span>

							<span class="iconfont" v-if="detailInfo.activity">&#xe631;</span>
							<span v-if="detailInfo.activity">{{
								detailInfo.activity.name
							}}</span>
						</span>
						<!-- {{ chooseinfo}} -->
						<!-- <span>库存{{ currentStock }}件</span> -->
						<span>{{ $t('store.quantity') }}：{{ currentAmount }}</span>
					</div>

					<span class="iconfont close" v-on:click="closeCartInfo(false)">&#xe65a;</span>
				</div>

				<div class="goods-detail-properties">
					<div
						v-if="
							detailInfo &&
								detailInfo.goods_spec
						"
						v-for="(item, index) in detailInfo.spec_name"
						:key="index"
					>
						<div
						class="goods-properties"
						v-if="detailInfo.spec_value[index] && Object.keys(detailInfo.spec_value[index]).length"
						>
						<p>{{ item }}</p>
						<div class="properties-list">
							<div v-for="(key, keyindex) in detailInfo.spec_value[index]" :key="keyindex">
								<span
									@click="setCurrentIndex(keyindex,detailInfo.spec_value[index])"
									v-bind:class="{
										'active-properties': detailInfo.goods_spec[keyindex]
									}"
									>{{ key }}</span
								>

							</div>
						</div>
						</div>
					</div>
					<div class="info-body" id="info-body">
						<p>{{ $t('store.quantity') }}</p>
						<div class="ui-number">
							<div
								class="reduce ui-common"
								@click.stop="reduceNumber()"
								v-bind:class="{ 'reduce-opacity': currentAmount <= 0 }"
							>
								-
							</div>
							<input
								type="number"
								min="1"
								class="number"
								value="1"
								v-model="currentAmount"
							/>
							<div class="add ui-common" @click.stop="addNumber()">+</div>
						</div>
					</div>
				</div>
				<div v-if="!ifInStore" class="info-footer">
					<div
						class="footer-button"
						:class="canBuy?'active-cart':'disabled-cart'"
						v-on:click="checkProduct(false)"
					>
						{{addCartText}}
					</div>
					<!-- <div
							class="footer-button"
							:class="canBuy?'active-buy':'disabled-buy'"
							v-on:click="checkProduct(true)"
					>
						{{buyNowText}}
					</div> -->

				</div>
				<div v-else class="info-footer" :style="getBannerStyle">
					<div class="footer-button" v-on:click="checkProduct(false)" :class="canBuy?'active-cart':'disabled-cart'">{{ $t('general.enter') }}</div>
				</div>
			</div>
		</div>
	</mt-popup>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import { Toast } from 'mint-ui'
import { cartAdd, cartDelete } from '../../../../api/homecart'

export default {
	data () {
		return {
			addCartText: this.$t('store.add_to_cart'),
			buyNowText: this.$t('store.buy_now'),
			currentAmount: this.$store.state.goodsdetail.number,
			currentStock: this.$store.state.goodsdetail.detailInfo.goods_storage,
			// productId: this.$store.state.goodsdetail.currentProductId,
			toastConfig: {
				message: this.$t('store.max_quantity'),
				position: 'middle'
			},
			ids: [],
			info: [],
			propertiPrice: 0,
			earlier: {}
		}
	},

	props: {
		ifInStore:{
			type: Boolean,
			default: false
		},
		isShowcartInfo: {
			type: Boolean,
			default: false
		},
		tempGoods:{
			type: Object,
			default: function () {
				return {}
			}
		}
	},

	created () {
		if (this.detailInfo.promotion_type) {
			this.propertiPrice = this.detailInfo.promotion_price
		} else {
			this.propertiPrice = this.detailInfo.goods_price
		}
		this.info = this.chooseinfo.specification
		this.ids = Object.assign([], this.chooseinfo.ids)
	},

	computed: {
		...mapState({
			isOnline: state => state.member.isOnline,
			token: state => state.member.token,
			user: state => state.member.info,
			detailInfo: state => state.goodsdetail.detailInfo,
			storeInfo: state => state.goodsdetail.storeInfo,
			specList: state => state.goodsdetail.specList,
			originAmount: state => state.goodsdetail.number,
			chooseinfo: state => state.goodsdetail.chooseinfo,
			shopCart: state => state.goodsdetail.shopCart,
		}),
		canBuy() {
			return (
				this.detailInfo.goods_storage > 0 &&
				this.detailInfo.goods_state == 1 &&
				this.detailInfo.goods_verify == 1 &&
				((this.originAmount != 0 && this.currentAmount >= 0) ||
					(this.originAmount == 0 && this.currentAmount > 0)) &&
				this.originAmount != this.currentAmount
			)
		},
		getBannerStyle: function () {
			const { width } = window.screen
			let itemWidth = width
			return {
				width: itemWidth + 'px'
			}
		},
	},

	watch: {
		// numbers: function (value) {
		// 	if (value) {
		// 		let goods_storage = this.detailInfo.goods_storage

		// 		if (value <= 0) {
		// 			if(this.ifInStore){
		// 				if(value < 0){
		// 					this.numbers = 0
		// 				}
		// 			}else{
		// 				this.numbers = 1
		// 		console.log('trigger by watch')
		// 				this.toastConfig.message = this.$t('store.min_quantity')
		// 				Toast(this.toastConfig)
		// 			}


		// 		} else if (value > goods_storage) {
		// 			this.toastConfig.message = this.$t('store.out_of_quantity')
		// 			Toast(this.toastConfig)
		// 			this.numbers = goods_storage
		// 		}
		// 		this.saveNumber(this.numbers)
		// 	}
		// }
	},

	mounted () {},

	methods: {
		...mapActions({
			getGoodsDetail: 'getGoodsDetail',
		}),
		...mapMutations({
			saveCartState: 'saveCartState',
			saveNumber: 'saveNumber',
			saveChooseInfo: 'saveChooseInfo',
			saveProperties: 'saveProperties',
			setCartNumber: 'setCartNumber',
			saveSelectedCartGoods: 'saveSelectedCartGoods'
		}),

		// 关闭购物车浮层
		closeCartInfo (value) {
			this.saveCartState(value)
		},

		// 数量加
		addNumber () {
			if (this.detailInfo.goods_storage && this.currentAmount > this.detailInfo.goods_storage) {
				this.toastConfig.message = this.$t('store.out_of_quantity')
				Toast(this.toastConfig)
				this.currentAmount = this.detailInfo.goods_storage
			} else {
				this.currentAmount++
			}
		},

		// 数量减
		reduceNumber () {
			var step = 0
			// if(this.ifInStore){
			// 	step=0
			// }
			if (this.currentAmount > step) {
				this.currentAmount--
			} else {
				this.currentAmount = step
				this.toastConfig.message = this.$t('store.min_quantity')
				Toast(this.toastConfig)
			}
		},

		// 加入购物车
		checkProduct (checkout) {
			if (!this.user) {
				Toast(this.$t('guest.need_more_please_login'))
				return
			}

			if (!this.canBuy) {
				return
			}
			if (!this.isOnline) {
				this.$router.push({ name: 'HomeMemberLogin' })
			} else {
				if (checkout) { // 立即购买
					if (this.user.store_id == this.storeInfo.store_id) {
						Toast(this.$t('store.alerts.cannot_buy_your_own'))
						return
					}
					this.$router.push({ name: 'MemberBuyStep1', query: { buy_now: 1, cart_id: this.detailInfo.goods_id + '|' + this.currentAmount } })
				} else {
					if (this.ifInStore){
						this.$emit('add', this.detailInfo, this.currentAmount)
					} else {
						if (this.currentAmount === 0) {
							let idx = this.shopCart.goods.findIndex(item => item.goods_id == this.detailInfo.goods_id)
							let _this = this
							cartDelete(this.shopCart.goods[idx].cart_id).then(res => {
								this.$store.dispatch('deleteShopCart', {cart_id: _this.shopCart.goods[idx].cart_id})
								this.saveNumber(this.currentAmount)
								Toast(res.message)
								this.saveCartState(false)
								this.$router.push({ name: 'HomeStoredetail', query: { id: this.storeInfo.store_id }})
							}).catch(err => {
								Toast(err.message)
							})
						} else {
							cartAdd(this.detailInfo.goods_id, this.currentAmount).then(res => {
									// this.$parent.$emit('update-cart-num')
									this.$store.dispatch('addShopCart', res.result)
									this.saveNumber(this.currentAmount)
									Toast(res.message)
									this.saveCartState(false)
									this.$router.push({ name: 'HomeStoredetail', query: { id: this.storeInfo.store_id }})
								},
								error => {
									Toast(error.message)
								}
							)
						}
					}
				}
			}
		},

		keyDown (event) {},



		/*
		 * setCurrentIndex: 设置当前选中的规格的id,
		 * @parmas: index 当前规格的index
		 * @parmas: specList 同类规格的列表
		 */
		setCurrentIndex (index, specList) {
			let specIndex = []
			for (var k in specList) {
				if (typeof (this.detailInfo.goods_spec[k]) !== 'undefined') {
					delete this.detailInfo.goods_spec[k]
					this.detailInfo.goods_spec[index] = specList[index]
					break
				}
			}
			for (var k in this.detailInfo.goods_spec) {
				specIndex.push(k)
			}
			specIndex = specIndex.sort(this.sortNumber).join('|')
			// for(var i in this.tempGoods.spec_list){
			// 	if(this.tempGoods.spec_list[i].goods_id==this.specList[specIndex]){
			// 		console.log('set numbers')
			// 		this.numbers=this.tempGoods.spec_list[i].count?this.tempGoods.spec_list[i].count:0
			// 		break
			// 	}
			// }
			this.getGoodsDetail({ goods_id: this.specList[specIndex], token: this.token })
				.then(res => {
					this.currentAmount = this.originAmount
				})
				.catch(error => {
					Toast(error.message)
				})
		},
		sortNumber(a,b)
		{
			return a - b
		}

	}
}
</script>

<style lang="scss" scoped>
.mint-popup-bottom {
	overflow: initial;
	height: 70%;
}
.ui-add-shopping {
	/* position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	width: 100%;
	height: 100%; */
	/* z-index: 200; */
	/* background:rgba(0,0,0, 0.4); */
	.shopping-info {
		background: rgba(255, 255, 255, 1);
		height: 100%;
		position: absolute;
		width: -webkit-fill-available;
		/* bottom: 0; */
		z-index: 10;
		width: 100%;
		.info-header {
			padding: 0.75rem;
			display: flex;
			justify-content: flex-start;
			padding-bottom: 1.25rem;
			border-bottom: 1px solid rgba(232, 234, 237, 1);
			img.info-image {
				width: 6rem;
				height: 6rem;
				border-radius: 1px;
				margin-top: -0.75rem;
				position: absolute;
				top: -0.65rem;
			}
			div {
				padding-left: 6.75rem;
				width: 100%;
				span {
					display: block;
					color: #999999;
					&.header-price {
						font-size: 0.9rem;
						line-height: 1rem;
						padding-bottom: 0.6rem;
						color: $primaryColor;
					}
					&:nth-child(2) {
						img {
							vertical-align: middle;
							padding-right: 0.5rem;
							width: 2.5rem;
							height: 1rem;
						}
						span {
							display: inline;
							font-size: 0.7rem;
							line-height: 0.7rem;
							padding-bottom: 0.45rem;
							padding-top: 0.6rem;
						}
					}
					&:nth-child(3) {
						line-height: 1rem;
						font-size: 0.7rem;
						line-height: 1rem;
						width: 100%;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
						padding-right: 0.75rem;
					}
					&:last-child {
						line-height: 1rem;
						font-size: 0.7rem;
						line-height: 1rem;
						padding-top: 0.6rem;
						width: 100%;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
						padding-right: 0.75rem;
					}
				}
			}
			img.close {
				position: absolute;
				top: 0.75rem;
				right: 0.75rem;
				width: 0.65rem;
				height: 0.65rem;
				cursor: pointer;
				opacity: 1;
			}
		}
		div.goods-detail-properties {
			width: 100%;
			overflow: auto;
			height: auto;
			position: absolute;
			top: 6.2rem;
			bottom: 2.2rem;
			/* height: 100%; */
		}
		div.goods-properties {
			padding: 0.75rem 0;
			p {
				font-size: 0.8rem;
				color: rgba(41, 43, 45, 1);
				line-height: 0.8rem;
				margin: 0;
				padding: 0 0.75rem;
			}
			div.properties-list {
				div {
					display: inline-block;
					margin-left: 0.75rem;
					span {
						font-size: 0.7rem;
						color: rgba(78, 84, 93, 1);
						line-height: 0.7rem;
						display: inline-block;
						padding: 0.35rem 0.7rem;
						border: 1px solid #404245;
						border-radius: 0.1rem;
						cursor: pointer;
						margin-top: 0.75rem;
						&.active-properties {
							background: $primaryColor;
							color: rgba(255, 255, 255, 1);
							border: 1px solid $primaryColor;
						}
						&.disabled-properties {
							color: #b1b5bb;
							cursor: none;
							border: 1px solid #a2a6ad;
						}
					}
					/* &:nth-child(even) {
					margin-left: 0.75rem;
					} */
				}
			}
		}
		.info-body {
			padding: 0.75rem 0.75rem 1rem 0.75rem;
			p {
				font-size: 0.8rem;
				color: rgba(41, 43, 45, 1);
				line-height: 0.8rem;
				padding: 0;
				margin: 0;
				padding-bottom: 0.8rem;
			}
			div.ui-number {
				height: 1.5rem;
				display: flex;
				border-radius: 0.15rem 0 0 0.15rem;
				input,
				div {
					height: 1.4rem;
					line-height:1.4rem;
					text-align: center;
					color: #404245;
					display: inline-block;
					padding: 0;
					margin: 0;
					border: 0;
					outline-offset: 0;
				}
				.ui-common {
					line-height: 1.4rem;
					width: 1.4rem;
					height: 1.4rem;
					border: 1px solid #c7c7cd;
					cursor: pointer;
				}
				.reduce {
					border-right: 0;
				}
				.reduce-opacity {
					opacity: 0.4;
				}
				.add {
					border-left: 0;
				}
				input[type='number'] {
					width: 2rem;
					border: 1px solid #c7c7cd;
					border-radius: 0;
					border-image-width: 0;
					box-shadow: 0;
					vertical-align: bottom;
					&:focus {
						outline: none;
					}
				}
			}
		}
		.info-footer {
			width: 100%;
			position: fixed;
			bottom: 0;
			display: flex;
			.footer-button {
				flex: 1;
				color: #ffffff;
				line-height: 2.2rem;
				text-align: center;
				font-size: 0.8rem;
				height: 2.2rem;
			}
			.active-cart {
				background: $primaryColor;
			}
			.active-buy {
				background: #f40000;
			}
			.disabled-buy {
				background: #999999;
			}
			.disabled-cart {
				background: #c3c3c3;
			}
		}
	}
}
</style>
